import { Sweepstakes } from "@shared/components";
import { useUser } from "@shared/hooks/user";
import React from "react";
import { useDispatch } from "react-redux";

import { toggleBuyInternetTimeModal } from "../../../actions/actions";
import { BuyTimeButton } from "../../BuyTimeButton/BuyTimeButton";

import classes from "./style.module.css";

export const FooterDesktop: React.FC = () => {
  const user = useUser();
  const dispatch = useDispatch();

  return (
    <div className={classes.footerGame}>
      <div className={classes.footerGameBuyTimeButton}>
        <BuyTimeButton
          onClick={() => {
            dispatch(toggleBuyInternetTimeModal(true));
          }}
        />
      </div>
      <div className={classes.footerGameSweepstakes}>
        <Sweepstakes user={user} />
      </div>
    </div>
  );
};
